import { Tag } from "antd";
import { format } from "date-fns";
import dayjs from "dayjs";

export type IFilter = {
  [key: string]: {
    keyvalue: any;
    clearHandler: (value?: undefined) => void;
  };
};

export function SelectedFilters({ filters }: { filters: IFilter }) {
  const getvalue = (filterValue: any) => {
    switch (typeof filterValue) {
      case "string":
        return filterValue.trim() ? filterValue : null;
      case "number":
        return `> ${filterValue}`;
      case "boolean":
        return filterValue ? "True" : "False";
      case "object":
        if (Object.keys(filterValue || {}).length === 0) return null;
        if (Array.isArray(filterValue)) {
          if (filterValue.length === 0) return null;
          if (filterValue.every((item) => typeof item === "string")) {
            return filterValue.join(",");
          } else if (
            filterValue.every(
              (item) => typeof item === "object" && "percentage" in item
            )
          ) {
            return filterValue
              .map((item) => `${item?.name || item?.value}:${item.percentage}%`)
              .join(",");
          } else {
            return null;
          }
        } else if ("min" in filterValue || "max" in filterValue) {
          if (filterValue?.min && filterValue?.max) {
            return `>=${filterValue.min} && <=${filterValue.max}`;
          }
          if (filterValue?.min) {
            return `>=${filterValue?.min} `;
          }
          return `<=${filterValue?.max} `;
        } else if ("from" in filterValue && "to" in filterValue) {
          if (
            filterValue?.from &&
            filterValue?.to &&
            typeof filterValue?.from === "string" &&
            typeof filterValue?.to === "string" &&
            dayjs(filterValue?.from).isValid() &&
            dayjs(filterValue?.to).isValid()
          ) {
            return `${format(
              new Date(filterValue?.from).toISOString(),
              "dd MMM yyyy"
            )} - ${format(
              new Date(filterValue?.to).toISOString(),
              "dd MMM yyyy"
            )}`;
          } else if (filterValue?.from && filterValue?.to) {
            return `${filterValue?.from} - ${filterValue?.to}`;
          }
          return null;
        } else if ("percentage" in filterValue) {
          return `${filterValue.name}:${filterValue.percentage}`;
        } else {
          return null;
        }
      default:
        return null;
    }
  };

  return (
    <div style={{ overflow: "auto" }}>
      <div style={{ display: "flex", marginTop: Object.entries(filters).length > 0 ? 10 : 0 /*gap: "2px", padding: 10*/ }}>
        {Object.entries(filters).map(([key, value]) => {
          const filtervalue = getvalue(value.keyvalue);
          return filtervalue ? (
            <div key={key}>
              <Tag
                closable
                onClose={() => {
                  value.clearHandler();
                }}
              >
                {`${key} : ${filtervalue}`}
              </Tag>
            </div>
          ) : null;
        })}
      </div>
    </div>
  );
}
